var path = 'infrastructure/directives/views/control-group.html';
var html = "<div class=\"form-group form-group-narrow\"> <label ng-if=showLabel class=\"control-label col-sm-3\" for={{for}}>{{label}}</label> <div class=\"controls col-sm-9\" ng-transclude></div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/views/control-group.html
// module id = 5891954130911650
// module chunks = 1